import React from 'react';
import './MedicineDetailModal.css';

const MedicineDetailModal = ({ medicine, closeModal }) => {
  if (!medicine) return null;

  console.log('Medicine Object:', medicine); 

  const sanitizeClassName = (name) => {
    return name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase(); 
  };

  const formatAgeGroup = (ageGroup) => {
    if (!ageGroup) return '';
    return ageGroup
      .split('-')
      .map((part) => part.replace(/-/g, ' ').toLowerCase())
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) 
      .join(' ');
  };

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeModal}>
          <span>&times;</span>
        </button>

        <h1 className='heading'>{medicine.name}</h1>
        <p className='heading2'>Manufacturer: {medicine.company || "Unknown Company"}</p>

        <div className="modal-body-details">
          <p><strong>Ordered Date:</strong> {medicine.orderedDate}</p>
          <p><strong>Batch ID:</strong> {medicine.batchNumber}</p>
          <p><strong>Expiry Date:</strong> {medicine.expiryDate}</p>
          <p><strong>Description:</strong> {medicine.description}</p>

          <div>
            <strong className='tagged'>Uses:</strong>
            <ul className="tag-list">
              {medicine.tags.map((tag, index) => (
                <li key={index} className="tag">{tag}</li>
              ))}
            </ul>
          </div>

          <div className="medicine-quantity">
            <p><strong>Tablets Available:</strong> {medicine.tablets || 'N/A'}</p>
            <p><strong>Total Packets:</strong> {medicine.totalPackets || 'N/A'}</p>
          </div>

          <div className="age-group-container">
            <strong className='tagged'>Target Age Group:</strong>
            <div className={`age-group ${sanitizeClassName(medicine.ageGroup)}`}>
              {formatAgeGroup(medicine.ageGroup)}
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default MedicineDetailModal;
